import { Component, OnInit, ViewChild, type ElementRef } from '@angular/core';
import { BuyerSupplierChatComponent } from 'src/app/views/chat/buyer-supplier-chat/buyer-supplier-chat.component';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';
import moment from 'moment';
// Heavy libs (xlsx, exceljs, file-saver) are dynamically imported inside methods
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { HttpClient } from '@angular/common/http';
import { BuyerRfqSWRService, type BuyerRfqQuery } from './buyer-rfq-swr.service';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/views/chat/chat.service';
// import FileSaver, { saveAs } from 'file-saver';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'

};

@Component({
  selector: 'app-buyer-rfq-list',
  templateUrl: './buyer-rfq-list-new.component.html',
  styleUrls: ['./buyer-rfq-list-new.component.css'],
})
export class BuyerRfqListComponent {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild(BuyerSupplierChatComponent, { static: true })
  chatComponent!: BuyerSupplierChatComponent;
  userId!: number;
  userRole!: string;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  headerData: any;
  archivedLoaded: boolean = false;
  showLoader: boolean = true;
  nextMpsCode: number = 0;
  isChatOpen: boolean = false;
  searchKeyword: string = '';
  operationType: string = 'buyerRfq';
  AllRFQs: any[] = [];
  limit: number = 10; // Rows per page
  offset: number = 0; // Current page offset
  archivedLimit: number = 10; // Rows per page
  archivedOffset: number = 0; // Current page offset
  totalRecords: number = 0; // Total number of records
  archivedTotalRecords: number = 0;
  sortField: string = 'rfqDate';
  sortDirection: string = 'desc';
  docStatus: string = 'all';
  fromDate: any;
  toDate: any;
  selectedRfqDetails: number[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  showConfirmationDialogue: boolean = false;
  isWrapDescription: boolean = false;
  isLoading: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedArchivedRfq: number[] = [];
  buyerUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;

  // SWR subscriptions and keys
  private rfqListSub: Subscription | null = null;
  private currentRfqQueryKey: string | null = null;
  private rfqArchivedSub: Subscription | null = null;
  private currentRfqArchivedQueryKey: string | null = null;

  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Date', prop: 'rfqDate', visible: true },

    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
    { name: 'Actions', prop: 'action', visible: true },
    { name: 'Track Status', prop: 'trackStatus', visible: true },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },
  ];
  // Define toggleable columns
  columnOptions = [
    { key: 'quotationDate', label: 'Quote Date', visible: false },
    { key: 'rating', label: 'Rating', visible: false },
    { key: 'leadTime', label: 'Lead Time In Days', visible: false },
  ];

  cancelReason: string = '';
  customReason: string = '';
  statusColors: { [key: string]: string } = {
    Submitted: '#69d1d1',
    Declined: '#dd1102',
    Draft: '#1868db',
    // 'Lost': '#FFFFFF',
    Canceled: '#dd1102',
    Expired: '#202020',
    Unactioned: '#69d1d1',
  };

  filterStatuses = [
    { name: 'Submitted', label: 'RFQ' },
    { name: 'Draft', label: 'RFQ' },
    { name: 'Expired', label: 'RFQ' },

    { name: 'Cancelled', label: 'RFQ' },
    { name: 'ALL', label: 'RFQ' },
  ];

  items = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},

    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];
  archivedItems = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},

    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Submitted to Supplier:' },
    // { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    // { name: 'Declined', heading: 'RFQ Declined:' },
    // { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Expired', heading: 'RFQ Expired:' },
    // { name: 'Submitted', heading: 'RFQ Submitted:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
    { name: 'Canceled', heading: 'RFQ Canceled:' },
    { name: 'Created', heading: 'RFQ Created:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Submitted' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  rfqStatuses = [
    'Unactioned',
    'Acknowledged',
    'Quoted',
    'Under Review',
    'Clarification Requested',
    'Approved',
    'Rejected',
    'Awarded',
    'Closed',
    'Open',
    'In Review',
    'Awaiting Supplier Response',
    'Canceled',
    'Draft',
    'Declined',
    'Lost',
    'Created',
  ];

  activeIndexes: number[] = [this.filterStatuses.length - 1];
  activeIndex: number = this.filterStatuses.length - 1;
  messages: { sender: string; message: string; time: string }[] = [];

  selectedStatus: string = 'ALL';

  rfqTypeDropdownOpen: boolean = false;

  previewSection = false;
  previewDocs: string[] = [];


  showContactPopup:boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax:'N/A'

  };

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private snack: MatSnackBar,
    private RfqGenerateFormService: RfqGenerateFormService,
    private iconRegistry: MatIconRegistry,
    private fullLoaderService: FullLoaderService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
    , private buyerRfqSWR: BuyerRfqSWRService
    , private http: HttpClient
    , private chatService: ChatService
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
      // this.sanitizer.bypassSecurityTrustResourceUrl(`https://mps-cdn-dev.s3.eu-west-1.amazonaws.com/assets/images/excel.svg`)
    );
  }

  async ngOnInit() {
    const queryParams = this.route.snapshot.queryParamMap;
    console.log('query params', queryParams);

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      console.log('statusParam', statusParam);
      console.log('labelParam', labelParam);

      if (statusParam && labelParam) {
        //  When params are present, use them
        this.selectedStatus = statusParam;
        this.docStatus = statusParam;
        const index = this.filterStatuses.findIndex(
          (status) => status.name.toLowerCase() === statusParam.toLowerCase()
        );

        this.activeIndex = index;
      } else {
        //  Fallback when params are NOT provided
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');
    await this.fetchAllDocuments();
   // await this.fetchArchivedAllDocuments();
   // await this.fetchUsers();
  }

  async fetchAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'buyerRfq';
    const q: BuyerRfqQuery = {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: this.limit,
      offset: this.offset,
      activeFlag: 1,
      operationType: this.operationType,
    };

    const key = this.buyerRfqSWR.keyOf(q);
    const needsResubscribe = this.currentRfqQueryKey !== key;
    const cached = this.buyerRfqSWR.getCached(q);
    this.showLoader = !cached;
    if (needsResubscribe) {
      if (this.rfqListSub) {
        this.rfqListSub.unsubscribe();
        this.rfqListSub = null;
      }
      this.currentRfqQueryKey = key;
      this.rfqListSub = this.buyerRfqSWR.getList$(q, true).subscribe(async (response) => {
        if (!response || !Array.isArray(response.rows)) return;
        const enrichedRows = await Promise.all(
          response.rows.map(async (rfq: any) => {
            if (this.expandedRowId === null) {
              this.expandedRowId = rfq.id ?? rfq.rfqId;
            }
            rfq.statusesStages = this.buildRfqStages(rfq);
            rfq.statusesStages = this.buildOtherStages(rfq);
            return rfq;
          })
        );
        this.documentData = enrichedRows;
        console.log("documentData",this.documentData);
        this.totalRecords = response.totalElements ?? 0;
        this.showLoader = false;
        this.loadUnreadChatCounts();
      });
    }
    if (!cached) {
      await this.buyerRfqSWR.refresh(q);
    } else {
      this.buyerRfqSWR.refresh(q);
    }
  }

  async fetchArchivedAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'buyerRfq';
    const q: BuyerRfqQuery = {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: this.archivedLimit,
      offset: this.archivedOffset,
      activeFlag: 0,
      operationType: this.operationType,
    };

    const key = this.buyerRfqSWR.keyOf(q);
    const needsResubscribe = this.currentRfqArchivedQueryKey !== key;
    const cached = this.buyerRfqSWR.getCached(q);
    this.showLoader = !cached;
    if (needsResubscribe) {
      if (this.rfqArchivedSub) {
        this.rfqArchivedSub.unsubscribe();
        this.rfqArchivedSub = null;
      }
      this.currentRfqArchivedQueryKey = key;
      this.rfqArchivedSub = this.buyerRfqSWR.getList$(q, true).subscribe(async (response) => {
        if (!response || !Array.isArray(response.rows)) return;
        const enrichedRows = await Promise.all(
          response.rows.map(async (rfq: any) => {
            rfq.statusesStages = this.buildRfqStages(rfq);
            rfq.statusesStages = this.buildOtherStages(rfq);
            return rfq;
          })
        );
        this.archivedDocumentData = enrichedRows;
        this.archivedTotalRecords = response.totalElements ?? 0;
        this.showLoader = false;
      });
    }
    if (!cached) {
      await this.buyerRfqSWR.refresh(q);
    } else {
      this.buyerRfqSWR.refresh(q);
    }
  }

  // Method to handle page change event from ngx-datatable
  onPageChange(event: any) {
    this.offset = event.offset; // Update offset from the page change event
    this.fetchAllDocuments(); // Fetch data with new offset
  }

  // Method to handle search functionality
  onSearch() {
    this.offset = 0; // Reset offset for new search
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    // this.fetchArchivedAllDocuments()
  }

  // Handle sort change event from ngx-datatable
  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    console.log('Sorting RFQ documents by', this.sortField, this.sortDirection);

    // Apply sorting and fetch data accordingly
    // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {}

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset; // Update offset from the page change event
    this.fetchArchivedAllDocuments(); // Fetch data with new offset
  }

  // async downloadRfq(filePath: string, refNo: string) {
  //   this.showLoader = true;
  //   let fileName = refNo + '.pdf';
  //   await this.dataTransferService.downloadFile(filePath, fileName);
  //   this.showLoader = false;
  // }

  OpenRfq(filePath: string) {
    window.open(filePath, '_blank');
  }

  editRfq(tabId: number, rfqId: number) {
    if (tabId == 1) {
      this.router.navigate(['dashboard', 'rfq', 'create', 'header'], {
        queryParams: { productType: 'cart', id: null, rfqId: rfqId },
      });
    } else if (tabId == 2) {
      this.router.navigate(['dashboard', 'rfq', 'create', 'line-items'], {
        queryParams: { productType: 'cart', id: null, rfqId: rfqId },
      });
    } else if (tabId == 5) {
      this.router.navigate(['dashboard', 'rfq', 'create', 'lpreview'], {
        queryParams: { productType: 'cart', id: null, rfqId: rfqId },
      });
    }
  }

  async resentRfq(rfqId: number) {
    this.showLoader = true;

    let formdata = {
      rfqId: Number(rfqId),
    };

    await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata);

    this.showLoader = false;
  }

  OpenSupplierProductPopUp(isNew?: boolean, row?: any, userId?: any) {
    this.router.navigate(
      [
        'dataManagement',
        {
          outlets: {
            'form-outlet': ['product-binding', userId],
          },
        },
      ],
      {
        state: { supplierId: userId }, // Add your data here
      }
    );
  }

  OpenSupplierPreviewPopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate([
      // "dataManagement",
      // 'pro',
      //  userId
      'settings',
      'profile',
      'about',
      userId,
      companyId,
    ]);
  }

  OpenSupplierProfilePopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate(['settings', 'supplierProfile', userId, companyId]);
  }

  openRfqPreview(rfqId:number){
  
      this.router.navigate([
        "/dashboard", 'quote','rfq-details', rfqId
        ]
        );
    
  }

  exportAll() {
    (async () => {
      try {
        this.fullLoaderService.showLoader('Exporting...');
        const XLSX = await import('xlsx');

        const exportData: any[] = this.documentData.map((docDetails) => ({
          Buyer: docDetails.companyName,
          'Document Type': docDetails.docType,
          Reference: docDetails.rfqRefNumber,
          Status: docDetails.docStatus,
          Date: docDetails.rfqDate,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'RFQs');
        XLSX.writeFile(wb, 'RFQ Data.xlsx');
      } catch (e) {
        console.error('Export failed', e);
        this.snack.open('Failed to export RFQ data.', 'OK', { duration: 3000 });
      } finally {
        this.fullLoaderService.hideLoader();
      }
    })();
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  // toggleArchived() {
  //   this.isArchivedExpand = !this.isArchivedExpand;
  //   if (this.isArchivedExpand && this.heading) {
  //     this.heading.nativeElement.scrollIntoView({
  //       behavior: 'smooth', // Smooth scroll
  //       block: 'start', // Align the section to the top of the viewport
  //     });
  //     setTimeout(() => {
  //       if (this.archivedSection) {
  //         this.heading.nativeElement.scrollIntoView({
  //           behavior: 'smooth',
  //           block: 'start', // Align the table at the top of the viewport after heading
  //         });
  //       }
  //     }, 100);
  //   }
  // }
  async toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      // Lazy-load archived data on first expand
      if (!this.archivedLoaded) {
        await this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }

      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start', // Align the section to the top of the viewport
        });
        setTimeout(() => {
          if (this.archivedSection) {
            this.heading.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // Align the table at the top of the viewport after heading
            });
          }
        }, 100);
      }
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find((col) => col.prop === prop);
    return column ? column.visible : false;
  }

  search() {}

  cancelFilter() {
    this.docStatus = 'all';
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    const ids = this.documentData.map((item) => item.rfqId);

    if (section == 'active') {
      if (checked) {
        this.selectedRfq = this.documentData.map((item) => item.rfqId);
        this.selectedRfqDetails = this.selectedRfq;
      } else {
        this.selectedRfq = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map(
          (item) => item.rfqId
        );
      } else {
        this.selectedArchivedRfq = [];
      }
    }
  }

  // selectDeselectRfq(event: any, supplierRfqDetailsId: any, section: string) {

  //   const checked = event.target.checked;

  //   if (section == 'active') {
  //     if (checked) {
  //       this.selectedRfq.push(supplierRfqDetailsId)
  //     }
  //     else {
  //       this.selectedRfq = this.selectedRfq.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }
  //   else {
  //     if (checked) {
  //       this.selectedArchivedRfq.push(supplierRfqDetailsId)
  //     }
  //     else {
  //       this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }

  // }

  // async rfqOperation(operation: string, rfqId :number) {

  //   this.selectedRfq.push(rfqId)

  //   let data = {
  //     operation:operation,
  //     selectedRfqId : this.selectedRfq
  //   }

  //     if (operation == 'delete') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ deleted successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //     else if (operation == 'restore') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ restored successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //     else if (operation == 'cancel') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ cancelled successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }
  //     else if (operation == 'resend') {
  //       this.showLoader = true;

  //       let formdata = {
  //         rfqId:Number(rfqId)
  //       }

  //       await this.RfqGenerateFormService.reSendRfqAcknowledgment(formdata)

  //       this.showLoader = false;
  //       this.snack.open('RFQ resent successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //   this.fetchAllDocuments()
  //   this.fetchArchivedAllDocuments()
  //   this.selectedArchivedRfq = []
  //   this.selectedRfq = []

  //   }

  selectDeselectRfq(
    event: any,
    rfqDetailsId: any,
    rfqId: any,
    section: string,
    owner: any
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(rfqId);
        this.selectedRfqDetails.push(rfqDetailsId);
        if(owner!== null){
          this.snack.open(`User is already assigned to RFQ ID ${rfqId}`, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== rfqId);
        this.selectedRfqDetails = this.selectedRfqDetails.filter(
          (id) => id !== rfqDetailsId
        );
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(rfqId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(
          (id) => id !== rfqId
        );
      }
    }
  }

  isChecked(rfqId: number, section: string) {
    if (section == 'active') {
      return this.selectedRfq.includes(rfqId);
    } else {
      return this.selectedArchivedRfq.includes(rfqId);
    }
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment(); // Get current time
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    // Handle the difference based on time
    if (diffInSeconds < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInSeconds} seconds ago)`;
    } else if (diffInMinutes < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInMinutes} minutes ago)`;
    } else if (diffInHours < 24) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInHours} hours ago)`;
    } else if (diffInDays === 1) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (Yesterday)`;
    } else {
      return moment(rfqDate).format('DD MMM YYYY'); // Show date with month and year
    }
  }

  getRemainingTime(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    if (
      !row.quotedByDate ||
      ['Lost', 'Declined', 'Expired'].includes(row.docStatus)
    ) {
      // if(row.docStatus=='Declined'){
      //   return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
      // }else if(row.docStatus=='Lost'){
      //    return { label: ' ', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
      // }
      // return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
      return { label: '', color: 'black', tooltip: '' };
    }

    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
      return { label: '', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
        // return { label: '-', color: '#000000', tooltip: 'Quote window closed'};
        return { label: '', color: '#000000', tooltip: '' };
      }
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000'; // Default to black if no match
  }

  openRfqDetails(rfqId: number) {
    console.log('Navigating to RFQ details');
    this.router.navigate(['/dashboard', 'rfq', 'create', 'header'], {
      queryParams: { productType: 'cart', rfqId: rfqId },
    });
  }
  // /dashboard/quote/create/preview?rfqId=302&quoteId=1
  // /dashboard/quote/quote-details?supplierId=326&quoteId=128&rfqId=550
  openQuoteDetails(rfqId: number, quoteId: number, supplierId: number) {
    console.log('Navigating to Quote details');
    this.router.navigate(['/dashboard', 'quote', 'quote-details'], {
      queryParams: { supplierId: supplierId, quoteId: quoteId, rfqId: rfqId },
    });
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  //  onStatusSelect(status: string, index: number, label: string) {
  //   this.activeIndex = index;
  //   if (label === 'RFQ') {
  //     if (this.selectedStatus.includes(status)) {
  //       return;
  //     }
  //     if (
  //       this.selectedStatus[0] === 'Unactioned' &&
  //       status === 'Acknowledged'
  //     ) {
  //       this.selectedStatus.push('Acknowledged');
  //       this.activeIndexes.push(index);
  //       this.docStatus += `,Acknowledged`;
  //     } else if (
  //       this.selectedStatus[0] === 'Acknowledged' &&
  //       status === 'Unactioned'
  //     ) {
  //       this.selectedStatus.push('Unactioned');
  //       this.activeIndexes.push(index);
  //       this.docStatus += `,Unactioned`;
  //     } else {
  //       if (status !== 'ALL') {
  //         this.docStatus = status;
  //       } else {
  //         this.docStatus = '';
  //       }
  //       this.selectedStatus = [status];
  //       this.activeIndexes = [index];
  //     }
  //     this.offset = 0;

  //     this.fetchAllDocuments();
  //   } else if (label === 'Quote') {
  //     this.router.navigate(['/operations/supplier-quote-list'], {
  //       queryParams: {
  //         selectedStatus: status,
  //         label: label,
  //       },
  //     });
  //   }
  // }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus.includes(status)) {
      return;
    }
    if (label === 'RFQ') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      console.log(
        'triggered status selection and now docstatus->',
        this.docStatus
      );
      this.fetchAllDocuments();
    } else if (label === 'Quote') {
      this.router.navigate(['/operations/supplier-quote-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    }
  }

  async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      // Build details IDs expected by buyer operations API
      const unarchivedIds = new Set(this.selectedArchivedRfq);
      console.log("unarchivedIds",unarchivedIds);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.rfqId));
      const selectedDetails = toUnarchive
        .map((row: any) => row.buyerRfqDetailsId)
        .filter((id: any) => id != null);

      await this.SettingsService.rfqOperations({
        operation: operation,
        selectedRfqId: selectedDetails,
      });
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.rfqId));
      if (toUnarchive.length > 0) {
        this.documentData = [...toUnarchive, ...this.documentData];
        this.totalRecords += toUnarchive.length;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      }

      // Patch caches for current pages
      const qArchived = this.buildBuyerQuery(0);
      const qActive = this.buildBuyerQuery(1);
      this.buyerRfqSWR.patchList(qArchived, (resp: any) => {
        const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.rfqId));
        const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
        return { ...resp, rows, totalElements: total };
      });
      this.buyerRfqSWR.patchList(qActive, (resp: any) => {
        const rows = toUnarchive.concat(resp?.rows || []);
        const total = (resp?.totalElements ?? 0) + toUnarchive.length;
        return { ...resp, rows, totalElements: total };
      });

      // Reset expanded row if it was among unarchived
      if (this.expandedRowId != null && toUnarchive.some(r => r.id === this.expandedRowId || r.rfqId === this.expandedRowId)) {
        this.expandedRowId = null;
      }

      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation: operation,
        selectedRfqId: this.selectedRfqDetails,
      };

      if (operation == 'archive') {
        this.showLoader = true;
        console.log('Data to make the rfq Archive->', data);
        await this.SettingsService.buyerRfqOperations(data);

        // Optimistically move items from active -> archived
        const archivedIds = new Set(this.selectedRfq);
        console.log("archivedIds",archivedIds);
        const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.rfqId));
        this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.rfqId));
        if (toArchive.length > 0 && this.archivedLoaded) {
          this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
          this.archivedTotalRecords += toArchive.length;
        }
        this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);

        // Patch caches for current pages
        const qActive = this.buildBuyerQuery(1);
        const qArchived = this.buildBuyerQuery(0);
        this.buyerRfqSWR.patchList(qActive, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.rfqId));
          const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
          return { ...resp, rows, totalElements: total };
        });
        if (this.archivedLoaded) {
          this.buyerRfqSWR.patchList(qArchived, (resp: any) => {
            const rows = toArchive.concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + toArchive.length;
            return { ...resp, rows, totalElements: total };
          });
        }

        // Reset expanded row if archived
        if (this.expandedRowId != null && toArchive.some(r => r.id === this.expandedRowId || r.rfqId === this.expandedRowId)) {
          this.expandedRowId = null;
          if (this.documentData.length > 0) {
            this.expandedRowId = this.documentData[0].id ?? this.documentData[0].rfqId;
            console.log("expandeRowId",this.expandedRowId);
          }
        }

        this.snack.open('Items archived', 'OK', { duration: 3000 });
      } else if (operation == 'markAsOpen') {
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data);
        this.showLoader = false;
        this.snack.open('Items marked as open', 'OK', {
          duration: 3000,
        });
      } else if (operation == 'markAsUnopen') {
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data);
        this.showLoader = false;
        this.snack.open('Items marked as unopen', 'OK', {
          duration: 3000,
        });
      }
    }

    // Background refresh without blocking UI
    this.fetchAllDocuments();
    if (this.archivedLoaded) {
      this.fetchArchivedAllDocuments();
    }
    this.selectedArchivedRfq = [];
    this.selectedRfq = [];
    this.showLoader = false;
  }

  private buildBuyerQuery(activeFlag: 0 | 1): BuyerRfqQuery {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    return {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: activeFlag === 1 ? this.limit : this.archivedLimit,
      offset: activeFlag === 1 ? this.offset : this.archivedOffset,
      activeFlag,
      operationType: this.operationType,
    };
  }

  ngOnDestroy() {
    if (this.rfqListSub) {
      this.rfqListSub.unsubscribe();
      this.rfqListSub = null;
    }
    if (this.rfqArchivedSub) {
      this.rfqArchivedSub.unsubscribe();
      this.rfqArchivedSub = null;
    }
  }

  selectedColumns: { label: string; prop: string }[] = [];
  updateSelectedColumns() {
    // Create a map of label to prop
    this.selectedColumns = this.items
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.items.filter((i) => i.selected)
    );
    this.updateSelectedColumns();
  }

  isValidQuoteDate(date: any): boolean {
    if (!date) return false;
    const d = new Date(date);
    return !isNaN(d.getTime()) && d.getFullYear() > 1970;
  }

  getRemainingTimeForQuoteDate(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      return { label: 'Overdue', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        return { label: 'Overdue', color: '#000000', tooltip: '' };
      }
    }
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  expandedRowId: number | null = null;
  toggleExpandedRow(row: any) {
    this.expandedRowId = this.expandedRowId === row.id ? null : row.id;
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined' || row.docStatus === 'Canceled') {
      return 'stage-declined';
    }

    // console.log('label received ->', label);
    switch (label) {
      case 'Declined':
        return 'stage-declined';
      case 'Expired':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.archivedItems.filter((i) => i.selected)
    );
    this.updateArchivedSelectedColumns();
  }
  archivedSelectedColumns: { label: string; prop: string }[] = [];
  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)

    console.log('archieve selected columns', this.archivedSelectedColumns);
  }

  async RestoreRfq(isConfirmed: boolean, row: any) {
    if (isConfirmed) {
      try {
        this.showLoader = true;
        await this.SettingsService.buyerRfqOperations({
          operation: 'unArchive',
          selectedRfqId: [row.buyerRfqDetailsId],
        });

        // Optimistically move one item from archived -> active
        const idx = this.archivedDocumentData.findIndex((r: any) =>
          (r.buyerRfqDetailsId != null && r.buyerRfqDetailsId === row.buyerRfqDetailsId) ||
          (r.rfqId != null && r.rfqId === row.rfqId)
        );
        if (idx !== -1) {
          const [moved] = this.archivedDocumentData.splice(idx, 1);
          this.documentData = [moved, ...this.documentData];
          this.totalRecords += 1;
          this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);

          // Patch caches for current pages
          const qArchived = this.buildBuyerQuery(0);
          const qActive = this.buildBuyerQuery(1);
          this.buyerRfqSWR.patchList(qArchived, (resp: any) => {
            const rows = (resp?.rows || []).filter((r: any) => !(
              (row.buyerRfqDetailsId != null && r.buyerRfqDetailsId === row.buyerRfqDetailsId) ||
              (row.rfqId != null && r.rfqId === row.rfqId)
            ));
            const total = Math.max(0, (resp?.totalElements ?? 0) - 1);
            return { ...resp, rows, totalElements: total };
          });
          this.buyerRfqSWR.patchList(qActive, (resp: any) => {
            const rows = [moved].concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + 1;
            return { ...resp, rows, totalElements: total };
          });
        }

        // Background refresh without blocking UI
        this.fetchAllDocuments();
        if (this.archivedLoaded) this.fetchArchivedAllDocuments();

        this.snack.open('RFQ has been restored successfully!', 'OK', {
          duration: 3000,
        });
      } catch (error) {
        console.error('Error while restoring RFQ:', error);
        this.snack.open('Failed to restore RFQ. Please try again.', 'OK', {
          duration: 3000,
        });
      } finally {
        this.showLoader = false;
      }
    } else {
      this.snack.open('Restore operation was canceled.', 'OK', {
        duration: 3000,
      });
    }
  }

  async fetchAllRfqs() {
    try {
      let fromDate = this.fromDate
        ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;
      this.operationType = 'export';
      console.log('During export hit docStatus->', this.docStatus);
      const response = await this.SettingsService.fetchAllRfqBybuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1,
        this.operationType
      );
      // console.log('Response from exportAllServicesByAdmin:', response);
      if (response && Array.isArray(response.rows)) {
        this.AllRFQs = response.rows;
      } else {
        console.error('Invalid response structure', response);
      }

      // console.log('Fetched All Quotes Data:', this.AllRFQs);
    } catch (error) {
      console.error('Error fetching all Quotes:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  async exportAllRfqs() {
    try {
      this.fullLoaderService.showLoader('Exporting RFQ Details...');

      await this.fetchAllRfqs();

      if (!this.AllRFQs || this.AllRFQs.length === 0) {
        alert('No RFQs available to export.');
        return;
      }
      console.log('All RFQs Data:', this.AllRFQs);

      const XLSX = await import('xlsx');

      const exportData: any[] = [];

      this.AllRFQs.forEach((row: any, index: number) => {
        const flattenedProduct = {
          'Sr. No.': index + 1,

          'RFQ Reference': row.rfqRefNumber || '',
          'Port Name': row.portName || '',
          'Vessel Name': row.vesselName || '',
          'Total Suppliers': row.suppliers?.length || '',

          Status:
            row.docStatus === 'Unactioned' ? 'Submitted' : row.docStatus || '',
          'RFQ Date': row.rfqDate || '',
          'Request For Delivery Date': row.requestDeliveryDate || '',
          'Quote Before Date': row.quotedByDate || '',
          'Vessel ETA': row.vesselEta || '',
          'Vessel ETD': row.vesselEtd || '',
        };

        exportData.push(flattenedProduct);
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        '0'
      )}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${today.getFullYear()}`;
      const fileName = `Buyer_RFQs_List_${formattedDate}.xlsx`;

      // Use XLSX to export data
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'RFQs');
      XLSX.writeFile(wb, fileName);

      this.snack.open('RFQs data exported successfully!', 'OK', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error while exporting RFQs:', error);
      this.snack.open('Failed to export RFQs data.', 'OK', {
        duration: 5000,
      });
    } finally {
      //this.importExportOperationLoader = false;
      this.fullLoaderService.hideLoader();
    }
  }

  buildRfqStages(rfq: any) {
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    // if(sortedStages.length !==0){
    //   rfq.docStatus = sortedStages[sortedStages.length -1].statusName;
    // }
    let rfqCount = 0;
    if (rfq.suppliers?.length > 0) {
      rfqCount = rfq.suppliers.length;
    }

    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;
    let hasCreated = false;
    let createdDate = '';
    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Unactioned') hasUnactioned = true;
      else if (stage.statusName === 'Created') hasCreated = true;
      else if (stage.statusName === 'Draft') {
        hasDraft = true;
        createdDate = this.formatDate(stage.createdAt);
      }
    }
    if (!hasCreated) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Created', 'RFQ'),
        label: 'RFQ Created',
        date:
          createdDate !== '' ? createdDate : this.formatRfqDate(rfq.rfqDate),
        completed: true,
      });
    }

    sortedStages.forEach((stage: any) => {
      stagesArray.push({
        heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
        label:
          stage.statusName === 'Unactioned'
            ? `RFQ Sent(${rfqCount})`
            : `RFQ ${stage.statusName}`,
        date: this.formatDate(stage.createdAt),
        completed: true,
      });
    });

    if (rfq.docStatus === 'Unactioned' && !hasUnactioned) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
        label: `RFQ Sent(${rfqCount})`,
        date: this.formatDate(rfq.rfqDate),
        completed: true,
      });
    }
    // If RFQ is expired, append it at the end (if not already in stages)
    if (
      (rfq.docStatus === 'Unactioned' || rfq.docStatus=== 'Expired') && this.isRfqLapsed(rfq.quotedByDate)  &&
      !stagesArray.some((s) => s.label === 'Expired')
    ) {
      console.log('RFQ has Expired for RFQ :', rfq.rfqRefNumber);
      rfq.docStatus = 'Expired';
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    // if (!hasAcknowledged && !hasDeclined) {
    //   stagesArray.push({
    //     heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
    //     label: 'Acknowledged',
    //     date: '',
    //     completed: false,
    //   });
    // }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    let quoteCount = 0;
    let latestQuoteDate = '';
    if (rfq.suppliers?.length > 0) {
      for (let supplier of rfq.suppliers) {
        if (supplier.rfqStatus === 3) {
          quoteCount++;
          latestQuoteDate = supplier.quotationDate;
        }
      }
    }
    console.log({quoteCount, latestQuoteDate});
    if (quoteCount > 0) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quote', 'Quote'),
        label: `Quotation received(${quoteCount})`,
        date: latestQuoteDate ? latestQuoteDate:'',
        completed: true,
      });
    } else {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quote', 'Quote'),
        label: ' Quotation received(0)',
        date: '',
        completed: false,
      });
    }
    
    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Created',
      date: '',
      completed: false,
    });
    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Sent',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  // formatDate(input: string | Date): string {
  //   // First, try converting the input to a Date object
  //   let date: Date;

  //   // Check if input is already a Date object, if not, try parsing the string
  //   if (input instanceof Date) {
  //     date = input;
  //   } else {
  //     // Try to parse the string into a valid date
  //     date = new Date(input);
  //     // If the parsed date is invalid, return an error message
  //     if (isNaN(date.getTime())) {
  //       throw new Error('Invalid date format');
  //     }
  //   }

  //   // Format the date to DD/MM/YYYY
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = String(date.getMonth() + 1).padStart(2, '0');
  //   const year = date.getFullYear();

  //   return `${day}/${month}/${year}`;
  // }

  alreadyAssignedBuyerUsers() {
    // Find all RFQs that already have a buyerUserName
    const alreadyAssignedRfqs = this.selectedRfq
      .map((rfqId: any) => {
        const rfq = this.documentData.find((data: any) => data.rfqId === rfqId);
        return rfq && rfq.buyerUserName ? rfq.rfqId : null;
      })
      .filter((rfqId: any) => rfqId !== null);

    console.log({ alreadyAssignedRfqs });
    if (alreadyAssignedRfqs.length > 0) {
      const rfqIds = alreadyAssignedRfqs.join(', '); // Join the RFQ IDs into a string
      this.snack.open(`User is already assigned to RFQ IDs: ${rfqIds}`, 'OK', {
        duration: 5000,
      });
      return;
    }
  }

  async toggleUserSelection(item: any) {
    // Check if any RFQs are selected
    if (this.selectedRfq.length === 0) {
      // If no RFQs are selected, show a snackbar message and return
      this.snack.open(
        'Please select at least one RFQ before selecting a user.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    item.selected = !item.selected;

    if (item.selected) {
      try {
        // Call the SettingsService to assign the user
        this.showLoader = true;
        const response = await this.SettingsService.assignRFQToBuyerUser(
          this.selectedRfq,
          Number(this.cookieService.get('userId')),
          item.id
        );
        // const result= await this.SettingsService.fetchSupplierUserByRfqId(this.selectedRfq[0]);
        // console.log({result});
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;
        this.showLoader = false;
        this.snack.open('User assigned to RFQ successfully.', 'OK', {
          duration: 3000,
        });
      } catch (error) {
        this.showLoader = false;
        // If the API call fails, handle the error here
        this.snack.open('Failed to assign user to RFQ.', 'OK', {
          duration: 3000,
        });
        throw error; // Re-throw the error to be caught in the calling method
      }
    }
  }
  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    // Check if we've reached the bottom of the menu content
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.buyerUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  async fetchUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')), // supplierId
        this.userlimit, // limit
        this.useroffset // offset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.buyerUsersList = [...this.buyerUsersList, ...response.rows];
        this.useroffset++; // Increment offset for next batch of users

        console.log('buyerUserList', this.buyerUsersList);
      } else {
        console.error('Invalid response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching buyer users:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async save(isConfirmed: boolean) {
    if (isConfirmed) {
      // Proceed with the save operation

      this.showLoader = true;

      if (this.cancelReason === 'Other') {
        this.cancelReason = this.customReason.trim();
      }
      console.log('cancel reason', this.cancelReason);
      console.log('RFQ cancelled');
      this.showConfirmationDialogue = false;
      let data = {
        selectedRfqId: this.selectedRfq,
        operation: 'cancelRfq',
        rfqStatus: 13,
      };

      await this.SettingsService.buyerRfqOperations(data);
      this.showLoader = false;
      this.snack.open('RFQ Cancelled', 'OK', {
        duration: 3000,
      });
      this.selectedRfq = [];
      await this.fetchAllDocuments();
    } else {
      // User cancelled the operation
      this.selectedRfq = [];
      this.showConfirmationDialogue = false;
    }
  }
  cancel() {
    this.selectedRfq = [];
    this.showConfirmationDialogue = false;
  }
  openCancellationBox(rfqId: any) {
    this.selectedRfq = [rfqId];
    this.showConfirmationDialogue = true;
  }

  get selectedRfqStatus() {

    // Step 2: Find the object in rfqList that matches the selected RFQ ID
    const selectedId = this.selectedRfq[0];
    const matchedRfq = this.documentData.find((item: any) => item.rfqId === selectedId);
  
    return matchedRfq ? matchedRfq.docStatus : null;
 }
  
  masterSelected: boolean = false;

  selectedCount: number = 4;

  // async onReminderClick(rfq: any) {
  //   console.log('Reminder clicked for RFQ:', rfq);
  //   if (this.selectedSupplierForReminders.length < 1) {
  //     this.snack.open(
  //       'Please select at least one supplier with status Acknowledged or Unactioned to send reminders.',
  //       'OK',
  //       { duration: 3000 }
  //     );
  //     return;
  //   }
  //   let data = {
  //     buyerId: Number(this.cookieService.get('userId')),
  //     rfqId: rfq.id,
  //     rfqRefNumber: rfq.rfqRefNumber,
  //     creationDate: this.formatDate(rfq.rfqDate),
  //     vesselName: rfq.vesselName,
  //     quoteBeforeDate: this.formatDate(rfq.quotedByDate),
  //     buyerName: rfq.buyerName,
  //     buyerLogo: rfq.organizationLogo,
  //     buyerCompanyName: rfq.buyerCompanyName,
  //     buyerEmail: rfq.buyerEmail,
  //     suppliers: this.selectedSupplierForReminders,
  //   };
  //   try {
  //     this.fullLoaderService.showLoader('Sending Reminders...');
  //     const response = await this.SettingsService.sendRfqRemindersByBuyer(data);
  //     if (response && response.success) {
  //       this.snack.open('Reminders sent successfully.', 'OK', { duration: 3000 });
  //       const rfqIdForChat = rfq.rfqId ?? rfq.id;
  //       const quoteBefore = this.formatDate(rfq.quotedByDate);
  //       for (const sup of this.selectedSupplierForReminders) {
  //         const reminderText = `Hi <b>${sup.supplierName}</b>,\n\nJust checking in on the RFQ <b>${rfq.rfqRefNumber}</b> for <b>${rfq.vesselName}</b>. We are awaiting your response on the requested items. Can you please provide your updated Quotation before <b>${quoteBefore}</b>?\n\nThanks!`;
  //         try {
  //           this.chatComponent?.sendProgrammaticMessage(rfqIdForChat, sup.supplierId, reminderText);
  //         } catch (e) {
  //           console.error('Failed to send chat reminder to supplier:', sup, e);
  //         }
  //       }
  //     } else {
  //       this.snack.open('Failed to send reminders.', 'OK', { duration: 3000 });
  //     }
  //     this.fullLoaderService.hideLoader();
  //   } catch (error) {
  //     console.error('Error sending reminders:', error);
  //     this.snack.open('An error occurred while sending reminders.', 'OK', { duration: 3000 });
  //     this.fullLoaderService.hideLoader();
  //   }
  // }

  // async sendReminder(rfq: any, supplier: any) {
  //   console.log('Reminder clicked for RFQ:', rfq);
  //   let data = {
  //     buyerId: Number(this.cookieService.get('userId')),
  //     rfqId: rfq.id,
  //     rfqRefNumber: rfq.rfqRefNumber,
  //     creationDate: this.formatDate(rfq.rfqDate),
  //     vesselName: rfq.vesselName,
  //     quoteBeforeDate: this.formatDate(rfq.quotedByDate),
  //     buyerName: rfq.buyerName,
  //     buyerLogo: rfq.organizationLogo,
  //     buyerCompanyName: rfq.buyerCompanyName,
  //     buyerEmail: rfq.buyerEmail,
  //     suppliers: [supplier],
  //   };
  //   try {
  //     this.fullLoaderService.showLoader('Sending Reminder...');
  //     const response = await this.SettingsService.sendRfqRemindersByBuyer(data);
  //     if (response && response.success) {
  //       this.snack.open('Reminder sent successfully.', 'OK', { duration: 3000 });
  //       this.openChat(
  //         {
  //           rfqId: rfq.rfqId ?? rfq.id, rfqDate: rfq.rfqDate, rfqRefNumber: rfq.rfqRefNumber,
  //           vesselName: rfq.vesselName, vesselImoNumber: rfq.vesselImoNumber, portName: rfq.portName,
  //           vesselEta: rfq.vesselEta, vesselEtd: rfq.vesselEtd, buyerId: rfq.buyerId,
  //         },
  //         { supplierId: supplier.supplierId }
  //       );
  //       const reminderText = `Hi <b>${supplier.supplierName}</b>,\n\nJust checking in on the RFQ <b>${rfq.rfqRefNumber}</b> for <b>${rfq.vesselName}</b>. We are awaiting your response on the requested items. Can you please provide your updated Quotation before <b>${this.formatDate(rfq.quotedByDate)}</b>?\n\nThanks!`;
  //       setTimeout(() => {
  //         try {
  //           if (this.chatComponent) {
  //             this.chatComponent.newMessage = reminderText;
  //             this.chatComponent.sendMessage();
  //           }
  //         } catch (e) {
  //           console.error('Failed to send chat reminder:', e);
  //         }
  //       }, 0);
  //     } else {
  //       this.snack.open('Failed to send reminders.', 'OK', { duration: 3000 });
  //     }
  //     this.fullLoaderService.hideLoader();
  //   } catch (error) {
  //     console.error('Error sending reminders:', error);
  //     this.snack.open('An error occurred while sending reminders.', 'OK', { duration: 3000 });
  //     this.fullLoaderService.hideLoader();
  //   }
  // }

  /**
   * Builds the reminder API payload for a given RFQ and supplier list.
   */
  private buildReminderPayload(rfq: any, suppliers: any[]) {
    return {
      buyerId: Number(this.cookieService.get('userId')),
      rfqId: rfq.rfqDetailsId ?? rfq.rfqId ?? rfq.id,
      rfqRefNumber: rfq.rfqRefNumber,
      creationDate: this.formatDate(rfq.rfqDate),
      vesselName: rfq.vesselName,
      quoteBeforeDate: this.formatDate(rfq.quotedByDate),
      buyerName: rfq.buyerName,
      buyerLogo: rfq.organizationLogo,
      buyerCompanyName: rfq.buyerCompanyName,
      buyerEmail: rfq.buyerEmail,
      suppliers,
    };
  }

  /**
   * Composes the reminder chat message for a supplier.
   */
  private composeReminderText(supplierName: string, rfqRef: string, vesselName: string, quoteBefore: string): string {
    return `Hi <b>${supplierName}</b>,\n\nJust checking in on the RFQ <b>${rfqRef}</b> for <b>${vesselName}</b>. We are awaiting your response on the requested items. Can you please provide your updated Quotation before <b>${quoteBefore}</b>?\n\nThanks!`;
  }

  async onReminderClick(rfq: any) {
    if (this.selectedSupplierForReminders.length < 1) {
      this.snack.open(
        'Please select at least one supplier with status Acknowledged or Unactioned to send reminders.',
        'OK',
        { duration: 3000 }
      );
      return;
    }

    const payload = this.buildReminderPayload(rfq, this.selectedSupplierForReminders);

    try {
      this.fullLoaderService.showLoader('Sending Reminders...');
      const response = await this.SettingsService.sendRfqRemindersByBuyer(payload);

      if (response && response.success) {
        this.snack.open('Reminders sent successfully.', 'OK', { duration: 3000 });

        // Send chat messages to each selected supplier silently
        const rfqIdForChat = rfq.rfqId ?? rfq.id;
        const quoteBefore = this.formatDate(rfq.quotedByDate);
        for (const sup of this.selectedSupplierForReminders) {
          const chatMsg = this.composeReminderText(sup.supplierName, rfq.rfqRefNumber, rfq.vesselName, quoteBefore);
          try {
            this.chatComponent?.sendProgrammaticMessage(rfqIdForChat, sup.supplierId, chatMsg);
          } catch (e) {
            console.error('Failed to send chat reminder to supplier:', sup, e);
          }
        }

        // Deselect all suppliers after successful reminder
        if (rfq.suppliers) {
          rfq.suppliers.forEach((s: any) => s.selected = false);
        }
        this.masterSelected = false;
        this.selectedSuppliers = [];
        this.selectedSupplierForReminders = [];
        this.selectedSuppliersQuotationForCompare = [];
      } else {
        this.snack.open('Failed to send reminders.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error sending reminders:', error);
      this.snack.open('An error occurred while sending reminders.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async sendReminder(rfq: any, supplier: any) {
    const payload = this.buildReminderPayload(rfq, [supplier]);

    try {
      this.fullLoaderService.showLoader('Sending Reminder...');
      const response = await this.SettingsService.sendRfqRemindersByBuyer(payload);

      if (response && response.success) {
        this.snack.open('Reminder sent successfully.', 'OK', { duration: 3000 });

        // Open chat drawer for the supplier
        this.openChat(
          {
            rfqId: rfq.rfqId ?? rfq.id,
            rfqDate: rfq.rfqDate,
            rfqRefNumber: rfq.rfqRefNumber,
            vesselName: rfq.vesselName,
            vesselImoNumber: rfq.vesselImoNumber,
            portName: rfq.portName,
            vesselEta: rfq.vesselEta,
            vesselEtd: rfq.vesselEtd,
            buyerId: rfq.buyerId,
          },
          { supplierId: supplier.supplierId }
        );

        // Send the reminder text via chat after inputs propagate
        const chatMsg = this.composeReminderText(supplier.supplierName, rfq.rfqRefNumber, rfq.vesselName, this.formatDate(rfq.quotedByDate));
        setTimeout(() => {
          try {
            if (this.chatComponent) {
              this.chatComponent.newMessage = chatMsg;
              this.chatComponent.sendMessage();
            }
          } catch (e) {
            console.error('Failed to send chat reminder:', e);
          }
        }, 0);

        // Deselect the supplier after successful reminder
        supplier.selected = false;
        this.selectedSuppliers = this.selectedSuppliers.filter((s: any) => s.supplierId !== supplier.supplierId);
        this.selectedSupplierForReminders = this.selectedSupplierForReminders.filter((s: any) => s.supplierId !== supplier.supplierId);
      } else {
        this.snack.open('Failed to send reminders.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error sending reminders:', error);
      this.snack.open('An error occurred while sending reminders.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  onCompareClick() {
    // UI-only for now
  }

  onAddClick() {
    // UI-only for now (e.g., open add-supplier dialog)
  }

  // toggleWrapDescription(event: MatSlideToggleChange) {
  //   this.isWrapDescription = event.checked;
  // }
  openCurrencyLink() {
    window.open('https://www.exchangerate-api.com/', '_blank');
  }

  selectedSuppliers: any[] = [];
  selectedSupplierForReminders: any[] = [];
  selectedSuppliersQuotationForCompare: any[] = [];

  // Select all suppliers except declined ones
  selectAllSuppliers(suppliers: any[], row: any) {
    suppliers.forEach((supplier) => {
      if (supplier.rfqStatus !== 15) {
        supplier.selected = this.masterSelected;
      }
    });
    this.updateSelectedSuppliers(suppliers);
  }

  // When a single supplier is selected/deselected
  checkIfAllSelected(suppliers: any[], row: any) {
    this.masterSelected = suppliers
      .filter((s) => s.rfqStatus !== 15)
      .every((s) => s.selected);

    this.updateSelectedSuppliers(suppliers);
  }

  // // Update the array of selected suppliers
  // updateSelectedSuppliers(suppliers: any[]) {
  //   this.selectedSuppliers = suppliers.filter(
  //     (supplier) => supplier.selected && supplier.rfqStatus !== 15
  //   );
  //   this.selectedSupplierForReminders = this.selectedSuppliers.filter(
  //     (supplier) => (supplier.quoteStatus!==null && supplier.quoteStatus!==3) ||
  //     (supplier.quoteStatus===null && (supplier.rfqStatus === 2 || supplier.rfqStatus === null) )
  //   );
  //   this.selectedSuppliersQuotationForCompare = this.selectedSuppliers.filter(
  //     (supplier) => supplier.selected && supplier.rfqStatus === 3
  //   );
  // }

  /**
   * Filters selected suppliers into reminder-eligible and comparison-eligible lists.
   */
  updateSelectedSuppliers(suppliers: any[]) {
    // Exclude declined suppliers (rfqStatus 15)
    this.selectedSuppliers = suppliers.filter(
      (sup) => sup.selected && sup.rfqStatus !== 15
    );

    // Eligible for reminders: supplier has a non-declined quote, or has no quote and is unactioned/null
    this.selectedSupplierForReminders = this.selectedSuppliers.filter(
      (sup) => {
        const hasActiveQuote = sup.quoteStatus !== null && sup.quoteStatus !== 3;
        const isAwaitingResponse = sup.quoteStatus === null && (sup.rfqStatus === 2 || sup.rfqStatus === null);
        return hasActiveQuote || isAwaitingResponse;
      }
    );

    // Eligible for comparison: supplier has quoted (rfqStatus 3)
    this.selectedSuppliersQuotationForCompare = this.selectedSuppliers.filter(
      (sup) => sup.selected && sup.rfqStatus === 3
    );

    console.log('Selected Suppliers:', this.selectedSuppliers);
    console.log('Selected Suppliers for Reminders:', this.selectedSupplierForReminders);
    console.log('Selected Suppliers for Comparison:', this.selectedSuppliersQuotationForCompare);
  }
  getReqCurrency(amount: any, currencyCode: any): string {
    return `${currencyCode ? currencyCode : ''} ${amount}`;
  }

  exchangeRatesCache: { [base: string]: any } = {}; // cache to avoid repeated API calls

  // getConvertedAmount(supplier: any, buyerCurrency: string): string {
  //   const amount = supplier.totalReqCost;
  //   if (!amount) return 'N/A';

  //   // when toggle is OFF -> show buyer currency
  //   if (!this.isWrapDescription) {
  //     return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
  //   }

  //   // when toggle is ON -> convert to supplier currency
  //   const supplierCurrency = supplier.supplierCurrencyCode;
  //   const rates = this.exchangeRatesCache[buyerCurrency];

  //   if (rates && rates[supplierCurrency]) {
  //     const converted = (amount * rates[supplierCurrency]).toFixed(2);
  //     return `${converted} ${supplierCurrency}`;
  //   }

  //   // fallback until rates are fetched
  //   return `${amount} ${buyerCurrency}`;
  // }

  getConvertedAmount(supplier: any, buyerCurrency: string): string {
    const amount = supplier.totalReqCost;
    if (!amount) return 'N/A';

    // when toggle is OFF -> show buyer currency
    if (!this.isWrapDescription) {
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    }

    // when toggle is ON -> convert to supplier currency
    const supplierCurrency = supplier.supplierCurrencyCode || 'EUR';

    if (!supplierCurrency) {
      // this.snack.open(
      //   `Supplier "${supplier.supplierName}" does not have a currency code`,
      //   'Close',
      //   { duration: 4000 }
      // );
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`; // fallback
    }

    const rates = this.exchangeRatesCache[buyerCurrency];

    if (rates && rates[supplierCurrency]) {
      const converted = (amount * rates[supplierCurrency]).toFixed(2);
      return `${supplierCurrency} ${converted}`;
    }

    // currency code not found in API rates
    // this.snack.open(
    //   `Currency code "${supplierCurrency}" not supported for supplier "${supplier.supplierName}"`,
    //   'Close',
    //   { duration: 4000 }
    // );
    return `${buyerCurrency} ${amount}`;
  }

  toggleWrapDescription(event: any, row: any) {
    this.isWrapDescription = event.checked;

    if (this.isWrapDescription) {
      // fetch conversion rates for buyer currency if not already cached
      const baseCurrency = row.rfqReqCurrencyCode;

      if (!baseCurrency) {
        this.snack.open(`Buyer does not have a currency code`, 'Close', {
          duration: 4000,
        });
        return;
      }

      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe(
          (res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
              console.log(
                'Exchange rates fetched successfully:',
                res.conversion_rates
              );
            } else {
              console.error('API error:', res['error-type']);
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open(
                'Currency exchange API limit exceeded. Please renew the subscription to view actual conversion values. Some users may experience disruptions in currency conversion functionality.',
                'OK',
                { duration: 7000 }
              );
            } else {
              console.error('Error fetching exchange rates:', error);
            }
          }
        );
      }
    }
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  openChat(rfq: any, supplier: any) {
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      vesselEtd: rfq.vesselEtd,
      buyerId: rfq.buyerId,
      supplierId: supplier.supplierId,
    };

    this.isChatOpen = true;

    // Mark messages as read when buyer opens the chat
    this.chatService.markAsRead({
      rfqId: rfq.rfqId,
      buyerId: rfq.buyerId,
      supplierId: supplier.supplierId,
      userId: this.userId,
    }).subscribe();
  }

  closeChat() {
    this.isChatOpen = false;
    this.loadUnreadChatCounts();
  }

  loadUnreadChatCounts() {
    if (!this.userId) return;
    this.chatService.getUnreadCounts(this.userId).subscribe({
      next: (counts: any) => {
        const data = Array.isArray(counts) ? counts : counts?.data ?? [];

        // Build a map keyed by "rfqId_supplierId" for per-supplier unread counts
        const supplierCountMap = new Map<string, number>();
        // Also accumulate per-RFQ totals for the buyer-level badge
        const rfqTotalMap = new Map<number, number>();

        data.forEach((item: any) => {
          const key = `${item.rfqId}_${item.supplierId}`;
          supplierCountMap.set(key, item.unreadCount);
          rfqTotalMap.set(item.rfqId, (rfqTotalMap.get(item.rfqId) || 0) + item.unreadCount);
        });

        this.documentData = this.documentData.map((rfq: any) => {
          const rfqId = rfq.rfqId ?? rfq.id;
          const updatedSuppliers = rfq.suppliers?.map((supplier: any) => ({
            ...supplier,
            unreadChatCount: supplierCountMap.get(`${rfqId}_${supplier.supplierId}`) || 0,
          }));
          return {
            ...rfq,
            suppliers: updatedSuppliers,
            chatCount: rfqTotalMap.get(rfqId) || 0,
          };
        });
      },
      error: (err: any) => console.error('Failed to load unread chat counts:', err),
    });
  }

  async onUserMenuOpened() {
    console.log('User menu opened');
    console.log('Current buyerUsersList:', this.buyerUsersList)
    if (!this.buyerUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
    console.log('Buyer Users List:', this.buyerUsersList);
  }

  async downloadRfqForBuyer(refNo: string, row:any ) {

    this.fullLoaderService.showLoader()
    
    let fileName = refNo +'.pdf';
    
    let data = {
      rfqId: Number(row.rfqId)
    }
    const pdf = await this.SettingsService.generateRfqAttachmentForBuyer(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()

  }

  togglePreview(value: boolean, section:string, row?: any ) {
    this.previewSection = value;
    this.previewDocs = [];
    console.log(row.buyerAttachments,row.lineItemAttachments,'row')
    if (row && section == 'rfq') {
       this.previewDocs = [...row.buyerAttachments, ...row.lineItemAttachments]
    }
    else if(row && section == 'quote'){
      this.previewDocs = [...row.quoteHeaderAttachments, ...row.quoteLineItemAttachments]
    }
  }




  toggleContactPopUp(value: boolean, row?: any){
    this.showContactPopup = value;
  
    if(value){
      if(row){
  
        this.selectedSupplier = {
          companyName: row.supplierName,
          contactPerson: row.contactPerson,
          email: row.supplierEmail,
          phone: row.phone,
          address: row.address,
          fax: row.companyFax
      
        };
  
      }
  
    }
  }


  async downloadQuote( row:any, supplier:any ) {

    this.fullLoaderService.showLoader()
    
    const name = Math.random().toString(36).substring(2, 10);
  
    const fileName = `DOC-${name}.pdf`;

    
    let data = {
      supplierId: Number(supplier.supplierId),
      rfqId: Number(row.rfqId),
      quoteId:Number(supplier.quoteId)
    }
    const pdf = await this.SettingsService.generateQuoteAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()

  }



  async generateRFQExcelForBuyer(rfqId: number) {

    this.fullLoaderService.showLoader()

    let params = {
          rfqId: Number(rfqId)
        }
    const result = await this.SettingsService.fetchBuyerRfqAttachmentExcelData(params)
    
    console.log(result,'result')

    const fileName = result.rfqData.rfqRefNumber + '.xlsx'

    const data = {
      rfqRef: result.rfqData.rfqRefNumber,
      rfqDate: result.rfqData.rfqDate,
      preferredCurrency: result.rfqData.currencyId.currencyCode,
      vesselName: result.rfqData.vesselName,
      imoNumber: result.rfqData.vesselImoNumber,
      quoteByDate: result.rfqData.quotedByDate,
      requestedDeliveryDate: result.rfqData.requestedDeliveryDate,
      buyerDetails: {
        name: result.rfqData.buyerCompanyName,
        address: result.rfqData.companyAddress,
        contact: result.rfqData.contact,
        phone: result.rfqData.companyPhoneNumber,
        email: result.rfqData.companyEmailId,
        mpsBuyerCode: result.rfqData.mpsBuyerCode,
      },
      freightForwarderDetails: {
        PIC: result.rfqData.rffdPic,
        phone: result.rfqData.rffdphone,
        fax: result.rfqData.rffdfax,
        email: result.rfqData.rffdemailId,
        address: result.rfqData.rffdaddress,
      },
      portAgentDetails: {
        name: result.rfqData.portAgentNumber,
        phone: result.rfqData.rfqPortAgentphone,
        fax: result.rfqData.rfqPortAgentfax,
        email: result.rfqData.rfqPortAgentemailId,
        contact: result.rfqData.rfqPortAgentContact,
      },
      portDetails: {
        portName: result.rfqData.portName,
        vesselETA: result.rfqData.vesselEta,
        vesselETD: result.rfqData.vesselEtd,
      },
      lineItems: result.supplierLineItemdata.map((item: { partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; mappedSuppliers: any[]; }, index: number) => ({
        srNo: index + 1,
        partNumber: item.partNumber,
        itemDescription: item.itemDescription,
        qty: item.quantity,
        uom: item.uom,
        buyerComments: item.buyerComments,
        attachedSuppliers: item.mappedSuppliers.map(supplier => ({
          name: supplier.supplierName,
          email: supplier.supplierEmail
        }))
      }))
    };

   
  
    const Excel = await import('exceljs');
    const fileSaverMod = await import('file-saver');
    const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('RFQ');
  
    // === TITLE ===
    ws.mergeCells('A1:G1');
    const title = ws.getCell('A1');
    title.value = 'Request For Quotation';
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    ws.addRow([]);
  
    // === RFQ DETAILS HEADER ===
    const rfqHeader = ws.addRow(['RFQ DETAILS']);
    rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
    rfqHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
  
    // RFQ Info
    const rfqInfo = [
      ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
      ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
      ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
      ['Requested Delivery Date:', data.requestedDeliveryDate],
    ];
    rfqInfo.forEach((r: any[]) => {
      const row = ws.addRow(r);
      row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
    });
    ws.addRow([]);
  
    // === BUYER DETAILS ===
    const buyerHeader = ws.addRow(['Buyer Details']);
    buyerHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
    buyerHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    const buyer = [
      ['Name', data.buyerDetails.name],
      ['Address', data.buyerDetails.address],
      ['Contact', data.buyerDetails.contact],
      ['Phone', data.buyerDetails.phone],
      ['Email', data.buyerDetails.email],
    ];
    buyer.forEach(r => ws.addRow(r));
    ws.addRow([]);
  
    // === FREIGHT FORWARDER + PORT AGENT ===
    const faHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
    faHeader.eachCell((c: any) => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
    });
    ws.addRow([]);
  
    // const maxRows = Math.max(
    //   Object.keys(data.freightForwarderDetails).length,
    //   Object.keys(data.portAgentDetails).length
    // );
    // const ffd = Object.entries(data.freightForwarderDetails);
    // const pad = Array(maxRows - ffd.length).fill(['', '']);
    // const pad2 = Array(maxRows - Object.entries(data.portAgentDetails).length).fill(['', '']);
    // const padData = ffd.concat(pad);
    // const padAgent = Object.entries(data.portAgentDetails).concat(pad2);
  
    // for (let i = 0; i < maxRows; i++) {
    //   ws.addRow([
    //     padData[i][0],
    //     padData[i][1],
    //     '',
    //     padAgent[i][0],
    //     padAgent[i][1],
    //   ]);
    // }
  
    // ws.addRow([]);

    const freightEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const portAgentEntries = Object.entries(data.portAgentDetails || {}).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Ensure equal number of rows for both sections
    const maxRows = Math.max(freightEntries.length, portAgentEntries.length);
    const paddedFreight = [...freightEntries, ...Array(maxRows - freightEntries.length).fill(['', ''])];
    const paddedPortAgent = [...portAgentEntries, ...Array(maxRows - portAgentEntries.length).fill(['', ''])];
    
    // Add rows to worksheet (no borders, clean formatting)
    for (let i = 0; i < maxRows; i++) {
      const row = ws.addRow([
        paddedFreight[i][0], paddedFreight[i][1],
        '',
        paddedPortAgent[i][0], paddedPortAgent[i][1]
      ]);
    
    
    }

    ws.addRow([]);
  
    // === PORT DETAILS ===
    const portHeader = ws.addRow(['Port Details']);
    portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    portHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['Port Name', data.portDetails.portName]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
    ws.addRow(['Vessel ETD', data.portDetails.vesselETD]);
    ws.addRow([]);
  
    // === LINE ITEMS ===
    const liHeader = ws.addRow(['Line Items']);
    liHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
    liHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
  
    const tableHeader = ws.addRow([
      'Sr. No',
      'Part Number',
      'Item Description',
      'Qty',
      'UOM',
      'Buyer Comments',
      'Attached Suppliers',
    ]);
    tableHeader.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
  

  
    data.lineItems.forEach((item: { attachedSuppliers: any[]; srNo: any; partNumber: any; itemDescription: any; qty: any; uom: any; buyerComments: any; }) => {
      const supplierNames = item.attachedSuppliers.map((s) => s.name).join('\n'); // multiline
  
      const row = ws.addRow([
        item.srNo,
        item.partNumber,
        item.itemDescription,
        item.qty,
        item.uom,
        item.buyerComments,
        supplierNames,
      ]);
  
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle' };
      });
    });
    

    ws.addRow([]);  

    // VSMPS Buyer and Supplier section
    ws.addRow([`From VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);

    ws.addRow([]);
    ws.addRow(['Copyright Â© Varuna Sentinels BV. All rights reserved.']);
    // ws?.lastRow?.getCell(1).alignment = { horizontal: 'left' };
    // ws.lastRow?.getCell(1).font = { italic: true, size: 9, color: { argb: '808080' } };
  
    // === AUTO WIDTH ===
    const colCount = ws.actualColumnCount;
    for (let i = 1; i <= colCount; i++) {
      let maxLen = 12;
      ws.eachRow({ includeEmpty: true }, (r: any) => {
        const val = r.getCell(i).value;
        const len = val ? val.toString().length : 0;
        if (len > maxLen) maxLen = len;
      });
      ws.getColumn(i).width = Math.min(maxLen + 4, 40);
    }
  
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    });


    this.fullLoaderService.hideLoader()

  }

  async generateQuoteExcel(quoteId:number,rfqId: number, supplierId:number, ref:string) {

    this.fullLoaderService.showLoader()
  
    let fileName = 'Q-' + ref +'.xlsx';
    
    let params = {
      supplierId: Number(supplierId),
      rfqId: Number(rfqId),
      quoteId:Number(quoteId)
    }
    const result = await this.SettingsService.fetchQuoteAttachmentExcelData(params)

    
    console.log(result,'result')
  
  
    const data = {
      quoteDetails:{
        quoteRef:result.quoteData.quoteRefNumber,
        quotedDate:result.quoteData.quotationDate,
        pricesGoodUntil:result.quoteData.pricesGoodUntil,
        offeredQuality: result.quoteData.offeredQualityName,
        currency:result.quoteData.currencyCode,
        onTimeDeliveryOrderBy:result.quoteData.onTimeDeliveryOrderBy,
        quotedDeliveryInDays: result.quoteData.quotedDeliveryInDays,
        incoterms: result.quoteData.incotermsName,
        incotermsLocation: result.quoteData.incotermLocations,
        paymentTerms:result.quoteData.paymentTermsCondition,
        termsAndCondition: this.convertHtmlToPlainText(result.quoteData.termsAndConditions)
      },
      rfqDetails:{
        rfqRef: result.quoteData.rfqRefNumber,
        vesselName: result.quoteData.vesselName,
        imoNumber: result.quoteData.vesselImoNumber,
        hullNumber: result.quoteData.hullNumber,
        yardName: result.quoteData.yardName,
        yearBuilt:result.quoteData.yearBuilt,
        requestedDeliveryDate: result.quoteData.requestDeliveryDate,
      },
      
      buyerDetails: {  
        name: result.quoteData.buyerCompanyName,
        address: result.quoteData.buyerCompanyAddress,
        contact: result.quoteData.buyerContact,
        phone: result.quoteData.buyerCompanyPhone,
        email: result.quoteData.buyerCompanyEmail,
        mpsBuyerCode: result.quoteData.buyerMpsCode,
      },
      supplierDetails: {
        name: result.quoteData.supplierCompanyName,
        address: `${result.quoteData.supplierStreet}, ${result.quoteData.supplierCity}, ${result.quoteData.supplierCountry}, ${result.quoteData.supplierZipcode}`,
        contact: result.quoteData.supplierContact,
        phone: result.quoteData.supplierPhone,
        email: result.quoteData.supplierEmail,
        mpsSupplierCode: result.quoteData.supplierMpsCode,
      },
      freightForwarderDetails: {
        PIC: result.quoteData.qffpic,
        phone: result.quoteData.qffphone,
        fax: result.quoteData.qfffax,
        email: result.quoteData.qffemailId,
        address: result.quoteData.qffaddress,
      },
     
      portDetails: {
        portName: result.quoteData.portName,
        vesselETA: result.quoteData.vesselEta,
        vesselETD: result.quoteData.vesselEtd,
      },
      costSummary:{
        lineItemSubtotal:parseFloat(result.quoteData.lineItemSubtotal || 0).toFixed(2),
        otherCharges:result.quoteData.quoteLineItemFreight,
        totalAdditionalCOst:parseFloat(result.quoteData.freightValue || 0).toFixed(2),
        currency:result.quoteData.currencyCode,
        grandTotal: parseFloat(result.quoteData.subtotal || 0).toFixed(2)
      },
      lineItems: result.lineItemData.map((item: {
        partNo: any;
        supplierPartNo: any;
        description: any;
        supplierQuantity: any;
        unitOfMeasure: any;
        supplierUOM: any;
        unitCost: any;
        discountPercent: any;
        totalCost: any;
        leadTime: any;
        supplierComment: any; partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; 
}, index: number) => ({
        srNo: index + 1,
        partNumber: item.partNo,
        supplierPartNumber: item.supplierPartNo,
        itemDescription: item.description,
        requestedQty: item.quantity,
        quotedQuantity: item.supplierQuantity,
        requestedUom: item.unitOfMeasure,
        quotedUom: item.supplierUOM,
        unitCost: item.unitCost,
        discount: item.discountPercent,
        totalCost: item.totalCost,
        leadDays: item.leadTime,
        supplierRemarks: item.supplierComment || ''
       
        
      }))
    };
    
    
    
    const Excel = await import('exceljs');
    const fileSaverMod = await import('file-saver');
    const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('Quotation');

    // === TITLE ===
    ws.mergeCells('A1:G1');
    const title = ws.getCell('A1');
    title.value = 'Quotation';
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    ws.addRow([]);

    // === QUOTATION DETAILS ===
    const quoteHeader = ws.addRow(['QUOTATION DETAILS']);
    quoteHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9E1F2' },
    };
    quoteHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Quotation Info
    const quoteInfo = [
      [
        'Quote Ref:',
        data.quoteDetails.quoteRef,
        '',
        'On-Time Delivery Order By:',
        data.quoteDetails.onTimeDeliveryOrderBy,
      ],
      [
        'Quoted Date:',
        data.quoteDetails.quotedDate,
        '',
       
        'Quoted Delivery in Days:',
        data.quoteDetails.quotedDeliveryInDays,
      ],
      [
        'Prices Good Until:',
        data.quoteDetails.pricesGoodUntil,
        '',
        
        'Incoterms:',
        data.quoteDetails.incoterms,
      ],
      [
        'Offered Quality:',
        data.quoteDetails.offeredQuality,
        '',
        'Incoterms Location:',
        data.quoteDetails.incotermsLocation,
      ],
      [
        'Currency:',
        data.quoteDetails.currency,
        '',
        'Payment Terms:',
        data.quoteDetails.paymentTerms,
      ],
    ];
    quoteInfo.forEach((r: any[]) => {
      const row = ws.addRow(r);
      row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
    });
    ws.addRow([]);

    // === BUYER AND SUPPLIER DETAILS ===
    const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
    BsHeader.eachCell((c: any) => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
    });
    ws.addRow([]);

    // const BsmaxRows = Math.max(
    //   Object.keys(data.buyerDetails).length,
    //   Object.keys(data.supplierDetails).length
    // );

    // const bd = Object.entries(data.buyerDetails);
    // const bpad = Array(BsmaxRows - bd.length).fill(['', '']);
    // const bpad2 = Array(BsmaxRows - Object.entries(data.supplierDetails).length).fill(['', '']);
    // const bpadData = bd.concat(bpad);
    // const supp = Object.entries(data.supplierDetails).concat(bpad2);

    // for (let i = 0; i < BsmaxRows; i++) {
    //   ws.addRow([
    //     bpadData[i][0],
    //     bpadData[i][1],
    //     '',
    //     supp[i][0],
    //     supp[i][1],
    //   ]);
    // }

    const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Pad so both arrays have the same length
    const maxRows = Math.max(buyerEntries.length, supplierEntries.length);
    const paddedBuyer = [...buyerEntries, ...Array(maxRows - buyerEntries.length).fill(['', ''])];
    const paddedSupplier = [...supplierEntries, ...Array(maxRows - supplierEntries.length).fill(['', ''])];
    
  
    for (let i = 0; i < maxRows; i++) {
      const row = ws.addRow([
        paddedBuyer[i][0], paddedBuyer[i][1],
        '',
        paddedSupplier[i][0], paddedSupplier[i][1]
      ]);
    
    
      row.eachCell((cell: any) => {
        cell.alignment = { vertical: 'middle', wrapText: true };
      });
    }
    


    ws.addRow([]);


    const rfqHeader = ws.addRow(['RFQ Details']);
    rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f9bccb' } };
    rfqHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['Vessel Name', data.rfqDetails.vesselName]);
    ws.addRow(['Vessel IMO', data.rfqDetails.imoNumber]);
    ws.addRow(['Hull Number', data.rfqDetails.hullNumber]);
    ws.addRow(['Yard Name', data.rfqDetails.yardName]);
    ws.addRow(['Build Year', data.rfqDetails.yearBuilt]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETD]);
    ws.addRow([]);
    ws.addRow([]);


    const freightHeader = ws.addRow(['Freight Details']);
    freightHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    freightHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['PIC', data.freightForwarderDetails.PIC]);
    ws.addRow(['Phone', data.freightForwarderDetails.phone]);
    ws.addRow(['Fax', data.freightForwarderDetails.fax]);
    ws.addRow(['Email', data.freightForwarderDetails.email]);
    ws.addRow(['Address', data.freightForwarderDetails.address]);
    ws.addRow([]);
    ws.addRow([]);

  
    // === LINE ITEMS ===
    const liHeader = ws.addRow(['Line Items']);
    liHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'BDD7EE' },
    };
    liHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    const tableHeader = ws.addRow([
      'Sr. No',
      'Part Number',
      'Supplier Part Number',
      'Item Description',
      'Requested Qty',
      'Quoted Qty',
      'Requested UOM',
      'Quoted UOM',
      'Unit Cost',
      'Discount',
      'Total Cost' ,
      'Lead Days',
      'Supplier Remarks'
    ]);
    tableHeader.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Add Line Items
    data.lineItems.forEach((item: {
      supplierRemarks: any; srNo: any; partNumber: any; supplierPartNumber: any; itemDescription: any; requestedQty: any; quotedQuantity: any; requestedUom: any; quotedUom: any; unitCost: any; discount: any; totalCost: any; leadDays: any; supplierComment: any; 
}) => {
      const row = ws.addRow([
        item.srNo,
        item.partNumber,
        item.supplierPartNumber,
        item.itemDescription,
        item.requestedQty,
        item.quotedQuantity,
        item.requestedUom,
        item.quotedUom,
        item.unitCost,
        item.discount,
        item.totalCost,
        item.leadDays,
        item.supplierRemarks

      ]);
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle' };
      });
    });

    ws.addRow([]);



    const costSummaryHeader = ws.addRow(['Cost Summary']);
    costSummaryHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F9F9F9' },
    };
    costSummaryHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Cost Summary Table
    const costSummaryTableHeader = ws.addRow(['Description', 'Amount']);
    costSummaryTableHeader.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Line Total Amount
    const lineTotalRow = ws.addRow([
      'Line Total Amount',
      data.costSummary.lineItemSubtotal,
    ]);
    lineTotalRow.eachCell((cell: any) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Adding Additional Charges 
    let totalAdditionalCharges = 0;
    data.costSummary.otherCharges.forEach((charge: { freightDescription: any; freightValue: number; }) => {
      const row = ws.addRow([charge.freightDescription, charge.freightValue]);
      row.eachCell((cell: any) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
      totalAdditionalCharges += charge.freightValue;
    });

    // Total Additional Cost
    const totalAdditionalCostRow = ws.addRow([
      'Total Additional Cost',
      totalAdditionalCharges,
    ]);
    totalAdditionalCostRow.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Grand Total
    const grandTotalRow = ws.addRow([
      'Grand Total',
      `${data.costSummary.grandTotal} ${data.costSummary.currency}`,
    ]);
    grandTotalRow.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    ws.addRow([]);

    const termsHeader = ws.addRow(['Terms And Conditions']);
    termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    termsHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow([data.quoteDetails.termsAndCondition]);
    ws.addRow([]);
    ws.addRow([]);


    // === VSMPS Buyer and Supplier section ===
    ws.addRow([`From VSMPS Supplier: ${data.supplierDetails.mpsSupplierCode}`]);
    ws.addRow([data.supplierDetails.name]);
    ws.addRow([data.supplierDetails.address]);

    ws.addRow([]);
    
    ws.addRow([`To VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);

    ws.addRow([]);


    ws.addRow(['Copyright Â© Varuna Sentinels BV. All rights reserved.']);

    // === AUTO WIDTH ===
    const colCount = ws.actualColumnCount;
    for (let i = 1; i <= colCount; i++) {
      let maxLen = 12;
      ws.eachRow({ includeEmpty: true }, (r: any) => {
        const val = r.getCell(i).value;
        const len = val ? val.toString().length : 0;
        if (len > maxLen) maxLen = len;
      });
      ws.getColumn(i).width = Math.min(maxLen + 4, 40);
    }
  
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    });
  
  
    this.fullLoaderService.hideLoader()
  
  }


  convertHtmlToPlainText(html: string): string {
    if (!html) return '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Replace <li> with line breaks + bullet
    tempDiv.querySelectorAll('li').forEach(li => {
      li.insertAdjacentText('beforebegin', '\nâ€¢ ');
    });

    // Replace <br> and block tags with line breaks
    const blockTags = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
    blockTags.forEach(tag => {
      tempDiv.querySelectorAll(tag).forEach(el => {
        el.insertAdjacentText('beforebegin', '\n');
      });
    });

    const text = tempDiv.textContent || '';
    return text.replace(/\n{2,}/g, '\n').trim(); // Remove extra empty lines
  }

  toggleRfqTypeDropdown() {
    this.rfqTypeDropdownOpen = !this.rfqTypeDropdownOpen;
  }

  navigateToRfqType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/buyer-rfq-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/buyer-service-rfq-list']);
    }
  }

}




